import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../config/api';
import { API_URL } from '../config/api';
import PollCard from '../components/PollCard';
import { MdArrowBack } from 'react-icons/md';

function PollDetailPage() {
  const { pollId } = useParams();
  const navigate = useNavigate();
  const [poll, setPoll] = useState(null);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadPoll = useCallback(async () => {
    try {
      setLoading(true);
      const [pollRes, tagsRes] = await Promise.all([
        axios.get(`${API_URL}/api/polls/${pollId}`),
        axios.get(`${API_URL}/api/tags`)
      ]);
      setPoll(pollRes.data);
      setTags(tagsRes.data);
    } catch (err) {
      setError('Poll not found or has been removed.');
    } finally {
      setLoading(false);
    }
  }, [pollId]);

  useEffect(() => {
    loadPoll();
  }, [loadPoll]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-12 text-center">
        <p className="text-gray-500 font-rubik mb-4">{error}</p>
        <button
          onClick={() => navigate('/polls')}
          className="btn-primary px-6 py-2"
          data-testid="back-to-polls-btn"
        >
          Back to Polls
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 py-8" data-testid="poll-detail-page">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800 font-rubik mb-6 transition-colors"
        data-testid="poll-detail-back-btn"
      >
        <MdArrowBack className="text-lg" />
        Back
      </button>
      {poll && (
        <PollCard
          poll={poll}
          tags={tags}
          showResultsByDefault={poll.userAnswered}
          onPollUpdate={() => loadPoll()}
        />
      )}
    </div>
  );
}

export default PollDetailPage;
